module.exports = __webpack_public_path__ + "static/img/12.4b52f70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/12.jpg
// module id = UuPb
// module chunks = 1